module.exports = __webpack_public_path__ + "media/react/assets/Weightage-e4dc1e3a388fb1df767f5c209d278495.svg";